const ERROR_MAPPING: Record<string, string> = {
  "Invalid credentials": "errors.invalid_credentials",
  "Request was throttled": "errors.rate_limited",
  "Account is disabled": "errors.account_disabled",
  "New password required": "errors.new_password_required",
  "Invalid old password": "errors.invalid_old_password",
  "Password must be at least 8 characters": "errors.password_too_short",
  "This token can only be used to change password": "errors.temp_token_restricted",
  "Invalid or expired token": "errors.invalid_token",
};

export function mapBackendErrorToI18nKey(backendError: string): string {
  return ERROR_MAPPING[backendError] || "errors.unknown";
}
